import React, { useState } from "react";
import subscriptionService from "../services/subscriptionService";

const SubscribeButton = () => {
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(null);

  const handleSubscribe = async (tipoPlano) => {
    setErro(null);
    setCarregando(true);
    try {
      const data = await subscriptionService.createSubscription(tipoPlano);
      if (!data.init_point) {
        throw new Error("Link de pagamento não recebido");
      }
      window.location.href = data.init_point; // redireciona para checkout Mercado Pago
    } catch (error) {
      console.error("Erro ao criar assinatura:", error);
      setErro("Não foi possível iniciar o pagamento. Tente novamente.");
      setCarregando(false);
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      {erro && <p style={{ color: "red" }}>{erro}</p>}
      <button disabled={carregando} onClick={() => handleSubscribe("mensal")}>
        {carregando ? "Redirecionando..." : "Assinar Plano Mensal"}
      </button>
      <button
        disabled={carregando}
        style={{ marginLeft: "10px" }}
        onClick={() => handleSubscribe("anual")}
      >
        {carregando ? "Redirecionando..." : "Assinar Plano Anual"}
      </button>
    </div>
  );
};

export default SubscribeButton;
